import React, { createContext, useContext, useMemo, useReducer } from 'react';
export const SessionContext = /*#__PURE__*/createContext([]);
export const useSession = () => {
  return useContext(SessionContext);
};
export const useUserSession = () => {
  const [{
    user
  }, dispatch] = useSession();
  return useMemo(() => {
    return [user, statesOrCallback => {
      dispatch({
        type: SessionActionType.SET_USER,
        payload: typeof statesOrCallback === 'function' ? statesOrCallback(user) : statesOrCallback
      });
    }];
  }, [user]);
};
export const useOtherSession = () => {
  const [{
    others
  }, dispatch] = useSession();
  return useMemo(() => {
    return [others, statesOrCallback => {
      dispatch({
        type: SessionActionType.SET_OTHERS,
        payload: typeof statesOrCallback === 'function' ? statesOrCallback(others) : statesOrCallback
      });
    }];
  }, [others]);
};
export let ACCESS_TOKEN = null;
export let SESSION_STATE = null;
export let SessionActionType;

(function (SessionActionType) {
  SessionActionType["SET_TOKEN"] = "set-token";
  SessionActionType["SETTING_USER"] = "setting-user";
  SessionActionType["SET_USER"] = "set-user";
  SessionActionType["SET_REDIRECT"] = "set-redirect";
  SessionActionType["SET_OTHERS"] = "set-others";
  SessionActionType["UPDATE_OTHERS"] = "update-others";
  SessionActionType["REMOVE_OTHERS"] = "remove-others";
})(SessionActionType || (SessionActionType = {}));

const reducer = (prev, action) => {
  switch (action.type) {
    case SessionActionType.SET_TOKEN:
      ACCESS_TOKEN = action.payload;
      return { ...prev,
        initial: false,
        token: action.payload
      };
      break;

    case SessionActionType.SETTING_USER:
      return { ...prev,
        loading: !prev.received_once && action.payload
      };
      break;

    case SessionActionType.SET_USER:
      return { ...prev,
        loading: false,
        received_once: !!action.payload,
        user: action.payload
      };
      break;

    case SessionActionType.SET_REDIRECT:
      return { ...prev,
        redirect: action.payload
      };
      break;

    case SessionActionType.SET_OTHERS:
      return { ...prev,
        others: action.payload
      };
      break;

    case SessionActionType.UPDATE_OTHERS:
      return { ...prev,
        others: { ...prev.others,
          ...action.payload
        }
      };
      break;

    case SessionActionType.REMOVE_OTHERS:
      const others = { ...prev.others
      };

      if (Array.isArray(action.payload)) {
        action.payload.forEach(eachRemove => {
          delete others[eachRemove];
        });
      } else if (typeof action.payload === 'string' && action.payload in others) {
        delete others[action.payload];
      }

      return { ...prev,
        others
      };
      break;

    default:
      return prev;
      break;
  }
};

const Session = ({
  defaults,
  children
}) => {
  const value = useReducer(reducer, defaults);
  SESSION_STATE = value[0];
  return /*#__PURE__*/React.createElement(SessionContext.Provider, {
    value: value
  }, children);
};

export default Session;